/**
 * @generated SignedSource<<c66496c25cb521f876dac5a42fd2fcd2>>
 * @relayHash 237b04f22d9b44361b6e9b7436f12aa7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 995bea55a94fd3b763d25f287ae43c4506bba32bd0abef2bf4de024e2ba46bf9

import type { ConcreteRequest } from 'relay-runtime';
export type PaywallStatus = "ACTIVE" | "DEACTIVATED" | "UNSET" | "%future added value";
export type WhiteboardUnifiedQuery$variables = {
  contentId: string;
  contentVersion: number;
  spaceKey?: string | null;
};
export type WhiteboardUnifiedQuery$data = {
  readonly canvasToken: {
    readonly token: string;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors: ReadonlyArray<{
        readonly id: string | null;
        readonly status: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly hasInheritedRestrictions: boolean;
      readonly hasRestrictions: boolean;
      readonly hasViewRestrictions: boolean;
      readonly history: {
        readonly createdBy: {
          readonly accountId?: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly metadata: {
        readonly currentuser: {
          readonly favourited: {
            readonly isFavourite: boolean | null;
          } | null;
        } | null;
        readonly lastModifiedDate: string | null;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly referenceId: string | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
        readonly type: string | null;
      } | null;
      readonly status: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null> | null;
  } | null;
  readonly contentMediaSession: {
    readonly accessTokens: {
      readonly readOnlyToken: {
        readonly value: string;
      } | null;
      readonly readWriteToken: {
        readonly value: string;
      } | null;
    };
    readonly configuration: {
      readonly fileStoreUrl: string;
    };
  } | null;
  readonly dataSecurityPolicy: {
    readonly isDownloadAllowed: {
      readonly allowed: boolean | null;
    };
    readonly isExportAllowed: {
      readonly allowed: boolean | null;
    };
  } | null;
  readonly entitlements: {
    readonly whiteboardFeatures: {
      readonly smartConnectors: {
        readonly isEntitled: boolean;
      } | null;
      readonly smartSections: {
        readonly isEntitled: boolean;
      } | null;
    } | null;
  } | null;
  readonly paywallStatus: PaywallStatus | null;
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly homepage: {
        readonly id: string | null;
      } | null;
      readonly id: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly space: {
        readonly id: string | null;
      } | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type WhiteboardUnifiedQuery = {
  response: WhiteboardUnifiedQuery$data;
  variables: WhiteboardUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentVersion"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "referenceId"
},
v6 = {
  "kind": "ScalarField",
  "name": "title"
},
v7 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "hasRestrictions"
},
v9 = {
  "kind": "ScalarField",
  "name": "hasViewRestrictions"
},
v10 = {
  "kind": "ScalarField",
  "name": "hasInheritedRestrictions"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "key"
},
v13 = {
  "kind": "ScalarField",
  "name": "type"
},
v14 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "status"
},
v16 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v13/*: any*/),
    (v6/*: any*/),
    (v15/*: any*/)
  ]
},
v17 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
      "kind": "LinkedField",
      "name": "currentuser",
      "plural": false,
      "selections": [
        {
          "concreteType": "FavouritedSummary",
          "kind": "LinkedField",
          "name": "favourited",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavourite"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "value"
},
v19 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        (v18/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(keys:[\"import-source\",\"imported-page-modified-date\"])"
},
v20 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v21 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "KnownUser"
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v20/*: any*/),
  "type": "UnknownUser"
},
v23 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v24 = [
  (v4/*: any*/)
],
v25 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    },
    (v23/*: any*/)
  ],
  "concreteType": "PaginatedSpaceList",
  "kind": "LinkedField",
  "name": "spaces",
  "plural": false,
  "selections": [
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v11/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "homepage",
          "plural": false,
          "selections": (v24/*: any*/)
        }
      ]
    }
  ]
},
v26 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluence",
      "plural": false,
      "selections": [
        {
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "space",
          "plural": false,
          "selections": (v24/*: any*/)
        }
      ]
    }
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v27 = {
  "args": (v3/*: any*/),
  "kind": "ScalarField",
  "name": "paywallStatus"
},
v28 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "args": (v29/*: any*/),
  "concreteType": "CanvasToken",
  "kind": "LinkedField",
  "name": "canvasToken",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "token"
    }
  ]
},
v31 = [
  (v18/*: any*/)
],
v32 = {
  "args": (v29/*: any*/),
  "concreteType": "ContentMediaSession",
  "kind": "LinkedField",
  "name": "contentMediaSession",
  "plural": false,
  "selections": [
    {
      "concreteType": "MediaAccessTokens",
      "kind": "LinkedField",
      "name": "accessTokens",
      "plural": false,
      "selections": [
        {
          "concreteType": "MediaToken",
          "kind": "LinkedField",
          "name": "readOnlyToken",
          "plural": false,
          "selections": (v31/*: any*/)
        },
        {
          "concreteType": "MediaToken",
          "kind": "LinkedField",
          "name": "readWriteToken",
          "plural": false,
          "selections": (v31/*: any*/)
        }
      ]
    },
    {
      "concreteType": "MediaConfiguration",
      "kind": "LinkedField",
      "name": "configuration",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fileStoreUrl"
        }
      ]
    }
  ]
},
v33 = [
  {
    "kind": "ScalarField",
    "name": "isEntitled"
  }
],
v34 = {
  "concreteType": "Entitlements",
  "kind": "LinkedField",
  "name": "entitlements",
  "plural": false,
  "selections": [
    {
      "concreteType": "WhiteboardFeatures",
      "kind": "LinkedField",
      "name": "whiteboardFeatures",
      "plural": false,
      "selections": [
        {
          "concreteType": "SmartConnectorsFeature",
          "kind": "LinkedField",
          "name": "smartConnectors",
          "plural": false,
          "selections": (v33/*: any*/)
        },
        {
          "concreteType": "SmartSectionsFeature",
          "kind": "LinkedField",
          "name": "smartSections",
          "plural": false,
          "selections": (v33/*: any*/)
        }
      ]
    }
  ]
},
v35 = {
  "kind": "Literal",
  "name": "contentStatus",
  "value": "CURRENT"
},
v36 = {
  "kind": "Variable",
  "name": "contentVersion",
  "variableName": "contentVersion"
},
v37 = [
  {
    "kind": "ScalarField",
    "name": "allowed"
  }
],
v38 = {
  "concreteType": "Confluence_dataSecurityPolicy",
  "kind": "LinkedField",
  "name": "dataSecurityPolicy",
  "plural": false,
  "selections": [
    {
      "alias": "isExportAllowed",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "PAGE_EXPORT"
        },
        (v28/*: any*/),
        (v35/*: any*/),
        (v36/*: any*/),
        (v23/*: any*/)
      ],
      "concreteType": "DataSecurityPolicyDecision",
      "kind": "LinkedField",
      "name": "isActionEnabledForContent",
      "plural": false,
      "selections": (v37/*: any*/)
    },
    {
      "alias": "isDownloadAllowed",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "ATTACHMENT_DOWNLOAD"
        },
        (v28/*: any*/),
        (v35/*: any*/),
        (v36/*: any*/),
        (v23/*: any*/)
      ],
      "concreteType": "DataSecurityPolicyDecision",
      "kind": "LinkedField",
      "name": "isActionEnabledForContent",
      "plural": false,
      "selections": (v37/*: any*/)
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "WhiteboardUnifiedQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v14/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v22/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v30/*: any*/),
      (v32/*: any*/),
      (v34/*: any*/),
      (v38/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WhiteboardUnifiedQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v14/*: any*/),
              (v13/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v19/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v21/*: any*/),
                      (v22/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v30/*: any*/),
      (v32/*: any*/),
      (v34/*: any*/),
      (v38/*: any*/)
    ]
  },
  "params": {
    "cacheID": "237b04f22d9b44361b6e9b7436f12aa7",
    "id": "995bea55a94fd3b763d25f287ae43c4506bba32bd0abef2bf4de024e2ba46bf9",
    "metadata": {},
    "name": "WhiteboardUnifiedQuery",
    "operationKind": "query",
    "text": "query WhiteboardUnifiedQuery($contentId:ID!,$spaceKey:String,$contentVersion:Int!){content(id:$contentId){nodes{id,referenceId,title,operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status},metadata{currentuser{favourited{isFavourite}},lastModifiedDate},properties(keys:[\"import-source\",\"imported-page-modified-date\"]){nodes{key,value}},history{createdBy{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,confluence{space{id}}},paywallStatus(id:$contentId),canvasToken(contentId:$contentId){token},contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl}},entitlements{whiteboardFeatures{smartConnectors{isEntitled},smartSections{isEntitled}}},dataSecurityPolicy{isExportAllowed:isActionEnabledForContent(action:PAGE_EXPORT,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed},isDownloadAllowed:isActionEnabledForContent(action:ATTACHMENT_DOWNLOAD,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed}}}"
  }
};
})();

(node as any).hash = "3a27147e54d7dc7fee56b195174180ed";

export default node;
